module.exports = __webpack_public_path__ + "static/media/sc.5d8966f4.svg";